export const company = [
  { item: "About Us", link: "/about" },
  { item: "Contact", link: "/support" },
];

// export const buyCryptos = [
//   { item: "Buy Bitcoin", link: "/" },
//   { item: "Buy Dogecoin", link: "/" },
//   { item: "Buy BTC", link: "/" },
//   { item: "Buy Ethereum", link: "/" },
//   { item: "Buy Solana", link: "/" },
// ];
export const products = [
  { item: "Trading", link: "/spot-trade" },
  { item: "Market", link: "/market" },
  { item: "Spot", link: "/spot-trade" },
  { item: "Transfer", link: "/swap" },
  { item: "Convert", link: "/swap" },
];
export const support = [
  // { item: "24/7 Chat Support", link: "/" },
  // { item: "Support Centre", link: "/" },
  { item: "List Your Assets", link: "https://form.typeform.com/to/hudDGATR" },
  { item: "Advertisement", link: "/coming-soon" },
  {
    item: "Fees",
    link: "/fees",
  },
  // { item: "Terms of Use", link: "/" },
];

export const policies = [
  {
    item: "AML",
    link: "/policies/AntiMoneyLaunderingPolicyAML-Paraacrypto.pdf",
  },
  { item: "KYC", link: "/policies/KYCPolicy-ParaaCrypto.pdf" },
  { item: "Terms of Use", link: "/policies/TermsOfUse-ParaaCrypto.pdf" },
  { item: "Privacy Policy", link: "/privacy-policy" },
  // { item: "Privacy Policy", link: "/policies/PrivacyPolicy-ParaaCrypto.pdf" },
  // { item: "Custody Note", link: "/policies/CurstodyNote-ParaaCrypto.pdf"},
  // { item: "Advertisement Policy", link: "/policies/AdvertisementPolicy-ParaaCrypto.pdf"},
  {
    item: "Third Party Disclaimer",
    link: "/policies/ThirdPartyDisclaimer-ParaaCrypto.pdf",
  },

  // { item: "Unregulated Deposit Ordinance", link: "/policies/UnregulatedDepositOrdinanceCompliancePolicy-ParaaCrypto.pdf"},
  // { item: "Risk Disclosure Note", link: "/policies/RiskDisclosureNote-ParaaCrypto.pdf" },
];

export const navlinks = [company, products, policies, support];

export const formatLargeNumber = (num: number) => {
  if (isNaN(num) || num === null) return "Invalid number";
  if (num === 0) return "0";

  const isNegative = num < 0;
  num = Math.abs(num);

  const formatter = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: num < 1 ? 6 : 2,
    minimumFractionDigits: num >= 1 ? 2 : 0,
  });

  const formatted = formatter.format(num);
  return isNegative ? `-${formatted}` : formatted;
};

export const formatLargeUSDNumber = (number: number): string => {
  const trillion = 1000000000000;
  const billion = 1000000000;
  const million = 1000000;

  if (Math.abs(number) >= trillion) {
    return (
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number / trillion) + "T"
    );
  } else if (Math.abs(number) >= billion) {
    return (
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number / billion) + "B"
    );
  } else if (Math.abs(number) >= million) {
    return (
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number / million) + "M"
    );
  } else {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number);
  }
};
export const formatLargeINRNumber = (number: number): string => {
  const trillion = 1000000000000;
  const billion = 1000000000;
  const million = 1000000;

  if (Math.abs(number) >= trillion) {
    return (
      new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number / trillion) +
      " " +
      "T"
    );
  } else if (Math.abs(number) >= billion) {
    return (
      new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number / billion) + " B"
    );
  } else if (Math.abs(number) >= million) {
    return (
      new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number / million) + " M"
    );
  } else {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number);
  }
};
export const formatNumber = (number: number): string => {
  const trillion = 1_000_000_000_000;
  const billion = 1_000_000_000;
  const million = 1_000_000;

  const formatNumber = (num: number) =>
    new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);

  if (Math.abs(number) >= trillion) {
    return `${formatNumber(number / trillion)} T`;
  } else if (Math.abs(number) >= billion) {
    return `${formatNumber(number / billion)} B`;
  } else if (Math.abs(number) >= million) {
    return `${formatNumber(number / million)} M`;
  } else {
    return formatNumber(number);
  }
};

import { store } from "@/redux/store";
import { decryptData } from "./crypto";
import { jwtDecode, JwtPayload } from "jwt-decode";
import { logoutUser } from "./helpers";
import { setLoggedIn, setUser } from "@/redux/user/slice";

export const tokenExpiry = (token: any) => {
  const abc: any = decryptData(token);
  try {
    const decoded: any = jwtDecode<JwtPayload>(abc);

    if (decoded?.exp * 1000 < Date.now()) {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
};

export const tokenExpirySteps = () => {
  if (store?.getState()?.user?.user?._id) {
    logoutUser(store?.getState()?.user?.user?._id);
  } else {
    localStorage.removeItem("token");
    localStorage.clear();
    store.dispatch(setUser(null));
    store.dispatch(setLoggedIn(false));
    window.location.href = "/login";
  }
};
